import { TraceAPI } from './api/index.js';

export const trace = TraceAPI.getInstance();
